// extracted by mini-css-extract-plugin
export var askAiIcon = "_nn-9";
export var container = "_nn-0";
export var groupSeparator = "_nn-a";
export var highlight = "_nn-4";
export var resultIcon = "_nn-5";
export var resultItem = "_nn-7";
export var resultSubtitle = "_nn-3";
export var resultTitle = "_nn-2";
export var resultsList = "_nn-1";
export var searchGroup = "_nn-6";
export var selected = "_nn-8";